import { InvoiceItemType } from "@graffer-inc/cloud-gov-core";

type PaymentOperationTypeLiterals =
  | "CHARGE"
  | "REFUND"
  | "PARTIAL_REFUND"
  | "ADJUST_CHARGE"
  | "ADJUST_REFUND";

export type PaymentOperationJSON = {
  paymentTransactionType: PaymentOperationTypeLiterals;
  paymentId: string;
  amount: number;
  // TODO: モデルを分けるかどうか
  items: InvoiceItemType[];
  createdAt: Date;
};

export class PaymentOperation {
  constructor(
    readonly paymentTransactionType: PaymentOperationTypeLiterals,
    readonly paymentId: string,
    readonly amount: number,
    readonly items: InvoiceItemType[],
    readonly createdAt: Date,
  ) {}
}
